<template>
  <section class="page-dashbord-profile mt-5">
    <!-- <progress max="100" :value.prop="uploadPercentage"></progress> -->
    <app-loading :isFull="true" v-if="isLoading"/>
    <!-- <contact-form :inputs="basicInformation" :title="'اطلاعات اولیه'" class="mb-4" :action="false" @setFormData="uploadAvatar" /> -->
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header>
            <h2 class="text-right rtl font-18 mb-4">اطلاعات اولیه</h2>
            <p v-if="formBio && formBio.user_id">پروفایل خود را
              <router-link :to="'/user/'+formBio.user_id">اینجا</router-link>ببینید
            </p>
          </header>
        </div>
      </div>
      <div class="row wrapper-form shadow py-4">
        <div class="col-4 mb-4">
          <div class="parent-image">
            <upload-avatar
              pixelImage="150*150px"
              :defultFile="formBio.img ? appUrl.media +'/'+ formBio.img : defaultImg"
              @getFile="getFile"
              :height="'150'"
            />
            <b-progress
              show-progress
              animated
              :value="uploadPercentage"
              class="mt-2 w-100"
              v-if="uploadPercentage > 0"
              :variant="'info'"
            ></b-progress>
          </div>
        </div>
        <div class="col-8 mb-4">
          <div class="row pt-5">
            <div class="col-4">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required'"
                  name="fullname"
                  :class="{active:formBio.fullname != '' }"
                  v-model="formBio.fullname"
                >
                <span class="bar"></span>
                <label class="statr">نام و نام خانوادگی</label>
                <span v-if="errors.has('fullname')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
            <div class="col-4">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required'"
                  name="national_number"
                  :class="{active:formBio.national_number != '' }"
                  v-model="formBio.national_number"
                >
                <span class="bar"></span>
                <label class="statr">کد ملی</label>
                <span v-if="errors.has('national_number')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
            <div class="col-4">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required'"
                  name="jobPos"
                  :class="{active:formBio.jobPos != '' }"
                  v-model="formBio.jobPos"
                >
                <span class="bar"></span>
                <label class="statr">عنوان شغلی</label>
                <span v-if="errors.has('jobPos')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
            <div class="col-6">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required'"
                  name="workPlace"
                  :class="{active:formBio.workPlace != '' }"
                  v-model="formBio.workPlace"
                >
                <span class="bar"></span>
                <label class="statr">محل کار</label>
                <span v-if="errors.has('workPlace')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
            <div class="col-6">
              <div class="group-form">
                <input
                  type="text"
                  v-validate="'required|numeric'"
                  name="phonenumber"
                  :class="{active:formBio.phonenumber != '' }"
                  v-model="formBio.phonenumber"
                >
                <span class="bar"></span>
                <label class="statr">شماره تماس</label>
                <span v-if="errors.has('phonenumber')" class="is-danger">فیلد نباید خالی باشد</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="editor rtl text-right my-4">
            <label class="statr">بیوگرافی</label>
            <!-- <input type="hidden" v-validate="item.rule" :name="item.name"  v-model="item.model"> -->
            <quill-editor @ready="onEditorReady($event)" v-model="formBio.about"/>
          </div>
        </div>
      </div>
    </div>

    <div class="container pt-3">
      <div class="row">
        <div class="col-12">
          <header>
            <h2 class="text-right rtl font-18 mb-4">شبکه های اجتماعی</h2>
          </header>
        </div>
      </div>
      <div class="row wrapper-form shadow py-4">
        <div class="col-4">
          <div class="group-form mod-ltr">
            <strong
              class="text-left ltr d-inline-block holder"
              v-if="formBio.instagram === ''"
            >https://www.instagram.com/</strong>
            <input
              type="text"
              name="instagram"
              :class="{active:formBio.instagram != '' }"
              v-model="formBio.instagram"
            >
            <span class="bar"></span>
            <label>اینستاگرام</label>
          </div>
        </div>
        <div class="col-4">
          <div class="group-form mod-ltr">
            <strong
              class="text-left ltr d-inline-block holder"
              v-if="formBio.twitter === ''"
            >https://twitter.com/</strong>
            <input
              type="text"
              name="twitter"
              :class="{active:formBio.twitter != '' }"
              v-model="formBio.twitter"
            >
            <span class="bar"></span>
            <label>تویتر</label>
          </div>
        </div>
        <div class="col-4">
          <div class="group-form mod-ltr">
            <strong
              class="text-left ltr d-inline-block holder"
              v-if="formBio.facebook === ''"
            >https://www.facebook.com/</strong>
            <input
              type="text"
              name="facebook"
              :class="{active:formBio.facebook != '' }"
              v-model="formBio.facebook"
            >
            <span class="bar"></span>
            <label>فیس بوک</label>
          </div>
        </div>
        <div class="col-4">
          <div class="group-form mod-ltr">
            <strong
              class="text-left ltr d-inline-block holder"
              v-if="formBio.telegram === ''"
            >https://t.me/</strong>
            <input
              type="text"
              name="telegram"
              :class="{active:formBio.telegram != '' }"
              v-model="formBio.telegram"
            >
            <span class="bar"></span>
            <label>تلگرام</label>
          </div>
        </div>
        <div class="col-4">
          <div class="group-form mod-ltr">
            <strong
              class="text-left ltr d-inline-block holder"
              v-if="formBio.website === ''"
            >http://www.</strong>
            <input
              type="text"
              name="website"
              :class="{active:formBio.website != '' }"
              v-model="formBio.website"
            >
            <span class="bar"></span>
            <label>وب سایت</label>
          </div>
        </div>
      </div>
    </div>

    <div class="container pt-3 mb-5">
      <div class="row">
        <div class="col-12">
          <header>
            <h2 class="text-right rtl font-18 mb-4">اطلاعات حساب</h2>
          </header>
        </div>
      </div>
      <div class="row wrapper-form shadow py-4">
        <div class="col-4">
          <div class="group-form">
            <input
              type="text"
              v-validate="'required'"
              name="credit_card_number"
              :class="{active:formBio.credit_card_number != '' }"
              v-model="formBio.credit_card_number"
            >
            <span class="bar"></span>
            <label class="statr">شماره کارت</label>
            <span v-if="errors.has('credit_card_number')" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
        </div>
        <div class="col-4">
          <div class="group-form">
            <input
              type="text"
              v-validate="'required'"
              name="bank_account_number"
              :class="{active:formBio.bank_account_number != '' }"
              v-model="formBio.bank_account_number"
            >
            <span class="bar"></span>
            <label class="statr">شماره حساب</label>
            <span v-if="errors.has('bank_account_number')" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
        </div>
        <div class="col-4">
          <div class="group-form">
            <input
              type="text"
              v-validate="'required'"
              name="bank_name"
              :class="{active:formBio.bank_name != '' }"
              v-model="formBio.bank_name"
            >
            <span class="bar"></span>
            <label class="statr">نام بانک</label>
            <span v-if="errors.has('bank_name')" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container pt-3 mb-5">
      <div class="row">
        <div class="col-12">
          <div class="form-action mt-2">
            <button
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-if="formBio && !formBio.bio_id"
              v-ripple
              @click="saveEditProfile"
            >ذخیره اطلاعات</button>
            <button
              v-else
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
              @click="updateProfile"
            >بروزرسانی اطلاعات</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import contactForm from 'cp/contact-form.vue'
import uploadAvatar from 'cp/min-component/upload-photo.vue'
var vm
export default {
  name: 'page-dashbord-profile',
  components: {
    contactForm,
    uploadAvatar
  },
  data() {
    return {
      defaultImg: '../../static/img/avatar.png',
      data: '',
      isLoading: true,
      uploadPercentage: 0,
      formBio: {
        img: '',
        about: '',
        national_number: '',
        jobPos: '',
        workPlace: '',
        phonenumber: '',
        instagram: '',
        twitter: '',
        facebook: '',
        telegram: '',
        website: '',
        bank_account_number: '',
        credit_card_number: '',
        bank_name: ''
      }
    }
  },
  computed: {},
  methods: {
    onEditorReady(editor) {
      editor.format('direction', 'rtl')
      editor.format('align', 'right')
    },
    getFile(file, e) {
      if (!this.formBio.img) {
        this.formBio.img = file
      } else {
        this.updateAvatar(file, e)
      }
    },
    updateFullname() {
      axios.post('/users/edit-fullname', { fullname: this.formBio.fullname })
      this.$store.dispatch('auth/upsertUser', { fullname: this.formBio.fullname })
    },
    async updateAvatar(fileData, e) {
      try {
        var formData = new FormData()
        formData.append('img', fileData)
        let { data } = await axios.post('/bio/update-img-bio', formData, {
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round(progressEvent.loaded * 100 / progressEvent.total)
            )
          }.bind(this)
        })
        this.uploadPercentage = 0
        if (data.state !== 200) {
          if (data.state === 403) {
            this.$root.showWarnMsg({
              message: 'فرمت مجاز نمیباشد÷ ... '
            })
          }
          if (data.err == 500) {
            this.$root.showWarnMsg({
              message: 'نام عکس نباید طولانی باشد ...'
            })
            this.$root.showWarnMsg({
              message: 'مشکلی پیش آمده است '
            })
          }
          return
        }
        this.$root.showInfoMsg({
          message: 'با موفقیت انجام شد ...'
        })
        vm.$store.dispatch('auth/upsertUser', {
          img: data.img
        })
      } catch (error) {
        console.log(error)
      }
    },
    async saveEditProfile(value) {
      let result = await this.$validator.validate()
      if (!result) {
        this.$root.showWarnMsg({
          message: 'لطفا فرم را تکمیل کنید ... '
        })
        return
      }
      this.isLoading = true
      this.updateFullname()
      await this.$store.dispatch('dashboardProfile/saveBio', this.formBio)
      this.getBio(true)
      this.isLoading = false
    },
    async updateProfile(value) {
      let result = await this.$validator.validate()
      if (!result) {
        this.$root.showWarnMsg({
          message: 'لطفا فرم را تکمیل کنید ... '
        })
        return
      }
      this.updateFullname()
      this.isLoading = true
      await this.$store.dispatch('dashboardProfile/updateBio', this.formBio)
      this.isLoading = false
    },

    async getBio(loadImg) {
      let bio = await this.$store.dispatch('dashboardProfile/getBio')
      this.isLoading = false
      if (bio) {
        if (loadImg) {
          vm.$store.dispatch('auth/upsertUser', {
            img: bio.img
          })
        }
        this.formBio = bio
      } else {
        this.$root.showWarnMsg({
          message: 'لطفا پروفایل خود را تکمیل کنید ...'
        })
      }
    }
  },
  mounted() {
    vm = this
    this.getBio()
  }
}
</script>
<style lang="less">
@import (reference) "../../../assets/css/variable.less";
.page-dashbord-profile {
  .box-clear;
  .parent-image {
    // height: 150px;
    // overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/user/_id.vue